import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms"

export function emailOrPhoneValidator() : ValidatorFn {
    return (control:AbstractControl<string>) : ValidationErrors | null => {
      const value = control.value
  
      if(!value.length) {
        return { isEmpty : true }
      }
      
      // the string begins with + or only has digits
      const phonePattern = "^\\+?([0-9]+)$"
      if(value.match(phonePattern)){
        return null
      }
  
      // the string is an email
      const emailPattern = "^[a-zA-Z_\\-\\.0-9]+@[a-zA-Z_\\-0-9]+?\\.[a-zA-Z]{2,3}$"; 
      if(value.match(emailPattern)){
        return null
      }

      return { valid: false}
    }
  }